module.exports = __webpack_public_path__ + "img/info1.dc6b4c6e.png";